import CryptoJS from 'crypto-js';

class EncryptionService {
    constructor() {
        // CRA exposes REACT_APP_* variables
        this.secretKey = process.env.REACT_APP_DATA_Encryption_Key || 'your-secret-key-must-be-32-chars';
        this.secretIv = process.env.REACT_APP_DATA_Encryption_Secret || 'your-secret-iv16';
    }

    decrypt(encryptedData) {
        try {
            // Generate key and IV matching PHP implementation
            const keyWordArray = CryptoJS.SHA256(this.secretKey); // 32 bytes
            const ivFull = CryptoJS.SHA256(this.secretIv); // 32 bytes, need first 16
            // Slice first 16 bytes (4 words = 16 bytes) into new WordArray
            const ivWordArray = CryptoJS.lib.WordArray.create(ivFull.words.slice(0, 4), 16);

            const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);
            const decrypted = CryptoJS.AES.decrypt({ ciphertext }, keyWordArray, {
                iv: ivWordArray,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            // Convert to UTF8 string and parse JSON
            const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedString);
        } catch (error) {
            console.error('Decryption failed:', error);
            throw new Error('Failed to decrypt data');
        }
    }

    decryptUserInfo() {
        if(sessionStorage.getItem("User_info")){ 
           
        try {
            
            const encryptedData=JSON.parse(sessionStorage.getItem("User_info"));
            // Generate key and IV matching PHP implementation
            const keyWordArray = CryptoJS.SHA256(this.secretKey); // 32 bytes
            const ivFull = CryptoJS.SHA256(this.secretIv); // 32 bytes, need first 16
            // Slice first 16 bytes (4 words = 16 bytes) into new WordArray
            const ivWordArray = CryptoJS.lib.WordArray.create(ivFull.words.slice(0, 4), 16);

            const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);
            const decrypted = CryptoJS.AES.decrypt({ ciphertext }, keyWordArray, {
                iv: ivWordArray,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            // Convert to UTF8 string and parse JSON
            const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedString);
        } catch (error) {
            console.error('Decryption failed:', error);
            throw new Error('Failed to decrypt data');
        }
       }else  return [];
    }
    
 
    encrypt(data) {
        try {
            // Convert data to JSON string
            const jsonString = JSON.stringify(data);
            
            // Generate key and IV matching PHP implementation
            const keyWordArray = CryptoJS.SHA256(this.secretKey);
            const ivFull = CryptoJS.SHA256(this.secretIv);
            const ivWordArray = CryptoJS.lib.WordArray.create(ivFull.words.slice(0, 4), 16);

            const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
                iv: ivWordArray,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        } catch (error) {
            console.error('Encryption failed:', error);
            throw new Error('Failed to encrypt data');
        }
    }
}

export default new EncryptionService();